import React, { useEffect, useState } from "react";
import { Button, Pagination, TuneIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Table from "~/components/Table";
import Wrapper from "~/shared/ui/Wrapper";
import { defaultValueActsFilterIProps } from "~/entity/Ivideon";
import { useGetIvideonHistoryActs } from "~/entity/Ivideon/hooks/useGetIvideonHistoryActs";
import { cleanFilters } from "~/entity/Ivideon/lib/cleanFilters";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";

import HistoryActsFilter from "./HistoryActsFilter";
import { fromServer } from "./helper";
import { defaultValueActsFilter } from "./HistoryActsFilter/options";
import { HISTORY_DOCUMENTS } from "./options";

import s from "./HistoryRegisterOfDocuments.less";

export default function HistoryRegisterOfDocuments() {
  const [filters, setFilters] = useState<defaultValueActsFilterIProps>(() => {
    const saved = sessionStorage.getItem("filterActs");
    return saved ? JSON.parse(saved) : defaultValueActsFilter;
  });

  const history = useHistory();
  const { t } = useTranslation();
  const { dealerId, dealerName, count, page, openModal } = useURLParamsGetter<{
    dealerId: string;
    dealerName: string;
    count: string;
    page: string;
    openModal: string;
  }>();
  const setURLParams = useURLParamsSetter();

  const { data, isLoading, isError, getParams } = useGetIvideonHistoryActs();

  const goBack = () => {
    history.push("/ivideon/register-of-documents");
  };

  const handleApplyFilters = (newFilters: defaultValueActsFilterIProps) => {
    setFilters(newFilters);
    sessionStorage.setItem("filterActs", JSON.stringify(newFilters));
  };

  useEffect(() => {
    if (dealerId) {
      const activeFilters = cleanFilters(filters);
      getParams({
        dealerId: Number(dealerId),
        page: page ? Number(page) : 0,
        limit: count ? Number(count) : 25,
        ...activeFilters,
      });
    }
  }, [dealerId, count, page, filters]);

  const getIvideonHistoryActs = (data: defaultValueActsFilterIProps) => {
    const activeFilters = cleanFilters(data);
    handleApplyFilters(data);
    getParams({
      dealerId: Number(dealerId),
      page: page ? Number(page) : 0,
      limit: count ? Number(count) : 25,
      ...activeFilters,
    });
  };

  const { handleCount, handlePage } = usePaginationParams("urlParams");

  const openActsFilter = () => {
    setURLParams({ openModal: "open" });
  };

  return (
    <>
      <Wrapper.Content
        title={`История действий по актам ${dealerName ?? ""}`}
        goBackHandler={goBack}
        txtBtn="Назад"
        controlComponent={
          <Button
            size="middle"
            fontSize="12"
            color="secondary"
            icon={<TuneIcon />}
            onClick={openActsFilter}
          >
            Фильтры
          </Button>
        }
      >
        <Table
          items={data ? fromServer({ data, t, dealerName }) : []}
          options={HISTORY_DOCUMENTS}
          sortable={false}
          loading={isLoading}
          type="ivideonCameras.actsHistory"
          customClassName={s.tableNewStyle}
        />
        <Pagination
          count={Number(count) || 25}
          page={(Number(page) || 0) + 1}
          totalCount={data?.totalPages ?? 1}
          onChangeCount={handleCount}
          onChangePage={handlePage}
        />
      </Wrapper.Content>
      <HistoryActsFilter
        openModal={openModal}
        initialValues={filters}
        getIvideonHistoryActs={getIvideonHistoryActs}
      />
    </>
  );
}
